// map projection config strings for Proj4 JS
export const PROJ_WGS84 = 'WGS84'; // aka EPSG:4326
export const PROJ_UTM_ZONELESS = '+proj=utm'; // default "+ellps=WGS84"; need to append +zone=XX

// search types
export const SEARCH_TYPE_GEONAMES = 'Places';
export const SEARCH_TYPE_GEONAMES_PLACEHOLDER = 'Search for a location';

export const SEARCH_TYPE_LAT_LONG = 'Lat Long';
export const SEARCH_TYPE_LAT_LONG_PLACEHOLDER = '48.46616 -123.36113';

export const SEARCH_TYPE_UTM = 'UTM';
export const SEARCH_TYPE_UTM_PLACEHOLDER = '10U 473305E 5368177N';

export const SEARCH_TYPE_WFI = 'WFI';
export const SEARCH_TYPE_WFI_PLACEHOLDER = '12345678';

export const GEOLOCATE_TOOLTIP_LABEL = 'Go to your location';
